import React from 'react';
import { Square } from '@grubhubprod/gh-cookbook-react';

export const ParentAdminTableHeaderCell: React.FC = ({ children }) => {
  return <Square inset="md">{children}</Square>;
};
